// extracted by mini-css-extract-plugin
export default {"documento":"DetallesContrato_documento__U7QE1","content":"DetallesContrato_content__NJRQD"};